// extracted by mini-css-extract-plugin
export default {"accessList":"d734c04b57ef","accessWrapper":"abd2ebbbb2fd","userCount":"f3edebfd098b","permissionLevel":"c9d3f423c936","permissionLevelLabel":"a4718d78c349"};